import PropTypes from 'prop-types';
import AppShell from 'components/Layout/AppShell';
import CardsCarousel from 'components/CardsCarousel/CardsCarousel';

/**
 * En mobile/tablet: usa el CardsCarousel existente (Swiper horizontal).
 * En desktop (lg+): se envuelve en AppShell 'default' para alinear el ancho
 * con el resto del Home (UserBox/ShopBox) y evitar que la sección sobresalga.
 * CardsCarousel maneja el responsive de slides por breakpoint Swiper.
 */
const CardsCarouselBlock = ({ value, blockProps = {}, renderCmsItem = null }) => {
  const cards = (value?.items || []).map((item) => {
    const content = renderCmsItem ? renderCmsItem(item) : null;
    if (content) {
      return { id: item.id, content };
    }
    return {
      id: item.id,
      ...item.value,
    };
  });

  if (!cards.length) {
    return null;
  }

  return (
    <section className='cms-block cms-block--cards-carousel py-6 md:py-6 lg:py-8'>
      <AppShell variant='default'>
        <CardsCarousel
          title={value?.title}
          link={value?.link}
          cards={cards}
          {...blockProps}
        />
      </AppShell>
    </section>
  );
};

CardsCarouselBlock.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.object,
    items: PropTypes.array,
  }).isRequired,
  blockProps: PropTypes.object,
  renderCmsItem: PropTypes.func,
};

export default CardsCarouselBlock;
